import useModal from "../../services/useModal";
import PageContainer from '../common/PageContainer'
import PreSaleTimer from '../common/PreSaleTimer'
import SimpleButton from '../common/SimpleButton'
import mooLogo from "../../assets/images/logo_moo.webp"
import coin from "../../assets/images/coin.webp"
import coinBlure from "../../assets/images/coin_blure.webp"
import imgDoneCow from "../../assets/images/main_done_cow.webp"
import imgRefAva from "../../assets/images/main_ref_ava.webp"
import imgInviteBtn from "../../assets/images/btn_yellow.webp"
import imgRefBtn from "../../assets/images/btn_yellow_small.webp"
import imgTicket from "../../assets/images/main_ticket.webp"
import s from './MainScreen.module.css'
import ProgressBar from '../common/ProgressBar'
import Modal from "../common/Modal";
import ModalLanguageList from "../ModalLanguageList";
import FooterNavigation from "../FooterNavigation";
import ModalPreSale from "../ModalPreSale";
import languages from "../ModalLanguageList/languages-data";

import { RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { Trans } from "@lingui/react/macro";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { telegramShare } from "../../services/telegram";
import { setPresalePopupShown } from "../../redux/slices/gameSlice";

const MainScreen = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.game.user);
    const { metadata, presalePopupShown } = useSelector((state: RootState) => state.game);
    const selectedLanguage = useSelector((state: RootState) => state.game.user.app_language || "en");
    const currentLanguage = languages.find(({ language }) => language === selectedLanguage) || languages[0];
    const titlePreSaleStyle = selectedLanguage === "en" ? s.titlePreSaleEN : s.titlePreSale

    const navigate = useNavigate();
    useEffect(() => {
        if (user.active_state >= 14) return;
        navigate('/');
    }, [user.active_state]);

    // LANGUAGE
    const { isOpen: isModalOpenLanguage,
        isFadingOut: isFadingOutLanguage,
        openModal: openModalLanguage,
        closeModal: closeModalLanguage } = useModal();
    // PreSale
    const { isOpen: isModalOpenPreSale,
        isFadingOut: isFadingOutPreSale,
        openModal: openModalPreSale,
        closeModal: closeModalPreSale } = useModal();

    useEffect(() => {
        if (!metadata.is_presale || presalePopupShown) return;

        dispatch(setPresalePopupShown(true));
        openModalPreSale();
    }, [metadata.is_presale]);

    const { link, handleGenerateLink } = telegramShare(user, metadata.bot);

    const handleButtonClick = () => {
        navigator.clipboard.writeText(link)
            .then(() => {
            })
            .catch(err => {
            });
    };

    const formatNumbers = (num: number): string => {
        if (isNaN(num)) return "0";
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    return (
        <PageContainer>
            <SimpleButton className={s.langButton} onClick={() => openModalLanguage()}>
                <img className={s.imgLangButton} src={currentLanguage.imgPath} alt="flag" />
                <p className={s.langButtonText}>{currentLanguage.title}</p>
            </SimpleButton>

            <div className={s.containerScroll}>

                <div className={s.coinContainer} >
                    <img className={s.mooLogo} src={mooLogo} alt="moo-logo" />

                    <div className={s.valueBox}>
                        <div className={s.ticketBox}>
                            <p className={s.valueText}>{formatNumbers(user.tickets)}</p>
                            <img className={s.imgTicketSmall} src={imgTicket} alt="ticket" />
                        </div>
                        <div className={s.coinBox}>
                            <p className={s.valueText}>{formatNumbers(user.tokens)}</p>
                            <img className={s.imgCoin} src={coin} alt="coin" />
                        </div>
                    </div>
                </div>

                <div className={s.doneContainer}>
                    <img className={s.imgDoneCow} src={imgDoneCow} alt="cow" />
                    <div className={s.doneTextBox}>
                        {selectedLanguage === "en" && <>
                            <p className={s.titleEN}>Done! You're in!</p>
                            <p className={s.text}>You’ve successfully joined the MooArmy Airdrop campaign! <br /> The distribution starts soon — <br /> you’ll be among the first to know. <br /> Stay tuned!</p>
                        </>}
                        {selectedLanguage === "cn" && <>
                            <p className={s.title}>完成！你已加入！</p>
                            <p className={s.text}>你已成功加入 MooArmy 空投活动！<br /> 空投即将开始——你将第一时间收到通知。<br /> 敬请期待！</p>
                        </>}
                        {selectedLanguage === "ru" && <>
                            <p className={s.title}>ГОТОВО! <br />ТЫ В ДЕЛЕ!</p>
                            <p className={s.text}>Ты успешно добавлен в список <br /> участников Airdrop-кампании MooArmy! Совсем скоро начнётся раздача — мы уведомим тебя в числе первых. Оставайся на связи!</p>
                        </>}
                    </div>
                </div>

                <div className={s.pointsContainer}>
                    <img className={s.coinBlure} src={coinBlure} alt="coinBlure" />
                    <div className={s.pointsTextBox}>
                        <p className={s.titleSecondary}><Trans>More Points.</Trans></p>
                        <p className={s.titleSecondary}><Trans>More rewards.</Trans></p>
                        <p className={s.titleSecondary}><Trans>Starting now.</Trans></p>
                        <div className={s.pointsBox}>
                            <p className={s.textSecondary}><Trans>Your Points Earned:</Trans></p>
                            <div className={s.pointsBoxValue}>
                                <p className={s.pointsTextValue}>{user.tokens}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={s.refContainer}>
                    <img className={s.imgRefAva} src={imgRefAva} alt="ava" />
                    <div className={s.refContainerInner}>
                        <div className={s.refTopBox}>
                            <div className={s.refTextBox}>
                                {user.friends > 0 ? (
                                    <>
                                        <p className={`${s.title} ${s.colorYellow}`}>{user.friends}</p>
                                        <p className={s.title}><Trans>Referral</Trans></p>
                                    </>
                                ) :
                                    <>
                                        <p className={`${s.title} ${s.colorYellow}`}><Trans>No</Trans></p>
                                        <p className={s.title}><Trans>Referral</Trans></p>
                                    </>}
                            </div>

                            {user.friends == 0 ? (
                                <>
                                    <div className={s.refTextBox}>
                                        <p className={s.textSecondary}><Trans>Your friends list is empty.</Trans></p>
                                        <p className={s.textSecondary}><Trans>It's time to fix that!</Trans></p>
                                    </div>
                                </>
                            ) : null}
                        </div>

                        <div className={s.refGroupBox}>
                            <SimpleButton className={s.inviteButton} onClick={handleGenerateLink} imageUrl={imgInviteBtn}>
                                <p className={s.inviteButtonText}><Trans>Invite friends</Trans></p>
                            </SimpleButton>
                            <SimpleButton className={s.refButton} onClick={handleButtonClick} imageUrl={imgRefBtn} />
                        </div>
                    </div>

                    <div className={s.barContainer}>
                        <img className={s.imgTicket} src={imgTicket} alt="ticket" />
                        <div className={s.barBox}>
                            <p className={s.textSecondary}><span className={s.colorYellow}>{Math.min(user.friends || 0, 5)}</span><Trans>/5 friends = 1 Ticket for</Trans> <span className={s.colorWhite}><Trans>$20,000 Prizes</Trans></span></p>
                            <p className={s.textSecondary} style={{ marginBottom: '1vh' }}><Trans>Invite more to increase your chances!</Trans></p>
                            <ProgressBar current={user.friends} max={5} />
                        </div>
                    </div>
                </div>
            </div>

            <FooterNavigation />

            {isModalOpenLanguage && <Modal closeModal={closeModalLanguage} isFadingOut={isFadingOutLanguage}>
                <ModalLanguageList closeModal={closeModalLanguage} />
            </Modal>}

            {isModalOpenPreSale && <Modal closeModal={closeModalPreSale} isFadingOut={isFadingOutPreSale}>
                <ModalPreSale closeModal={closeModalPreSale} />
            </Modal>}
        </PageContainer>
    )
}

export default MainScreen